import cn from 'classnames'
import React from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { shouldUseFlagRequest } from 'partner360/features/topPartnersManagement/helpers/shouldUseFlagRequest'
import { TFlagChangeRequestStatus } from 'partner360/models/partnerFlagRequests/TFlagChangeRequestStatus'

import styles from './StatusBadge.module.scss'

interface IStatusBadgeProps {
  status?: Nullable<TFlagChangeRequestStatus>
}

export const StatusBadge = ({ status }: IStatusBadgeProps) => {
  if (!status || !shouldUseFlagRequest(status)) {
    return null
  }

  return (
    <div
      className={cn(styles.badge, {
        [styles.flagStatusNew]: status === 'New',
        [styles.flagStatusWip]: status === 'Wip',
        [styles.flagStatusApproved]: status === 'Approved',
        [styles.flagStatusRejected]: status === 'Rejected',
        [styles.flagStatusDeleted]: status === 'Deleted',
      })}
    >
      {status}
    </div>
  )
}
